<template>
  <sec-section>
    <!-- Pale-blue banner across the full width: icon and title on the left, the paragraph on
         the right. Stacks on phones. -->
    <sec-panel quiet class="not-cert">
      <div class="not-cert__grid">
        <div class="not-cert__lead" data-reveal>
          <span class="not-cert__badge" aria-hidden="true">
            <v-icon size="30">mdi-certificate-outline</v-icon>
          </span>
          <h2 class="o600 sec-h2 not-cert__title">{{ section.title }}</h2>
        </div>
        <p class="m500 not-cert__text" data-reveal>{{ section.text }}</p>
      </div>
    </sec-panel>
  </sec-section>
</template>

<script setup>
import SecSection from '@/components/security/ui/SecSection.vue';
import SecPanel from '@/components/security/ui/SecPanel.vue';
import { BASELINE } from '@/content/security/baseline';

const section = BASELINE.notCertification;
</script>

<style scoped>
.not-cert__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--sec-s3);
  align-items: center;
}

/* Icon and title on one row, vertically centred on each other. */
.not-cert__lead {
  display: flex;
  align-items: center;
  gap: 1.25rem;
}

.not-cert__badge {
  flex-shrink: 0;
  display: grid;
  place-items: center;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: var(--sec-surface);
  color: var(--sec-accent-text);
  box-shadow: 0 14px 28px -18px var(--sec-header-shadow);
}

.not-cert__title {
  margin: 0;
  text-wrap: balance;
}

/* The paragraph sits behind a thin DIGU Blue rule; on desktop the rule divides the two
   columns and both sides centre on each other. */
.not-cert__text {
  padding-left: 1.25rem;
  border-left: 3px solid var(--sec-accent);
  font-size: 1.125rem;
  line-height: 1.7;
  color: var(--sec-ink);
}

@media only screen and (min-width: 700px) {
  .sec-panel.not-cert {
    padding: 3rem;
  }
  .not-cert__badge {
    width: 64px;
    height: 64px;
    border-radius: 18px;
  }
  .not-cert__text {
    padding-left: 2rem;
    font-size: 1.25rem;
  }
}

@media only screen and (min-width: 1100px) {
  .not-cert__grid {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1.55fr);
    gap: 3rem;
  }
  .sec-panel.not-cert {
    padding: 3.5rem;
  }
}
</style>
